import { AuthUserPermission, Can } from '@cibo/profile'
import { useCiboAutoForm } from '@cibo/ui'

export const CiboAutoFormDebugger = () => {
  const form = useCiboAutoForm()

  return (
    <Can useAny={AuthUserPermission.DEBUG_USER}>
      <pre style={{ textAlign: 'left', marginTop: '1rem' }} data-testid="cibo-auto-form-debugger">
        {JSON.stringify({ model: form.model, error: form.error, warnings: form.warnings }, null, 2)}
      </pre>
    </Can>
  )
}
